<router-outlet></router-outlet>
<div *ngIf="loaderVisible" class="loader-main">
  <mat-spinner></mat-spinner>
</div>